<template>
  <div>
    <article class="con2">
      <div class="container">
        <p id="carrotIdentity" class="title-text">
          CARROT Core Value & Identity
        </p>
        <p class="sub-text">
          우리는 오직 우리의 존재 이유와 궁극적인 목표를 향해 나아갑니다.
        </p>
        <ul>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con2/img0.png"
                alt="img"
              />
              <p>CARROT의 철학<br />TRANSPARENCY & COMMUNICATION</p>
              <div></div>
              <p>
                투명성을 통해 '나'를 넘어서고,<br />열림을 통해서 더 큰 '하나'가
                되는 것.
              </p>
            </div>
          </li>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con2/img1.png"
                alt="img"
              />
              <p>CARROT의 MISSION<br />GROWING</p>
              <div></div>
              <p>
                Growing Me, The clients & The society<br />나와 고객과 세상의
                성장을 견인하는 것
              </p>
            </div>
          </li>
          <li>
            <div class="inner">
              <img
                src="@/assets/img/newGlobal/introduce/sub/philosophy/con2/img2.png"
                alt="img"
              />
              <p>CARROT의 VISION<br />21C 지식기반, 최고의 가치창출 기업</p>
              <div></div>
              <p>High Performance<br />High Standard<br />High Satisfaction</p>
            </div>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con2 {
  padding: 40px 0;
  background: #f3f3f3;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .title-text {
    font-size: 30px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }

  .sub-text {
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;

    @media screen and (min-width: 1350px) {
      margin-bottom: 50px;
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    @media screen and (min-width: 1350px) {
      grid-template-columns: repeat(3, 1fr);
    }

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 350px;
      height: 350px;
      margin: 0 auto;
      background-color: #ffffff;
      border-radius: 50%;

      .inner {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 30px;

        img {
          margin-bottom: 20px;
        }

        p {
          &:nth-of-type(1) {
            font-weight: 700;
          }

          &:nth-of-type(2) {
            font-size: 14px;
          }
        }

        div {
          width: 35px;
          height: 1px;
          background-color: #000000;
          margin: 20px 0;
        }
      }
    }
  }
}
</style>
